/**
 * Oxirgi `n` kun — KAMAYISH tartibida.
 *
 * ⚠️⚠️ **`slice()` bilan NUSXA olinadi.** AYNI massiv `summarise` va
 * `toDayCells` ga ham boradi, `reverse()` esa JOYIDA ishlaydi — nusxasiz
 * u 30 kunlik lentaning tartibini jimgina ag'darib yuborardi va hech
 * qanday test yiqilmasdi.
 *
 * ⚠️⚠️ **Teskarilash MAJBURIY.** `GET /attendance/days` repozitoriysi
 * kunlarni O'SISH tartibida qaytaradi va `useEmployeeAttendanceDays` uni
 * o'zgartirmaydi. Teskarilashsiz jadval eng ESKI beshta kunni ko'rsatib,
 * «Oxirgi davomat kunlari» sarlavhasini yolg'onga aylantirardi.
 *
 * ⚠️ **Bu funksiya `utils/summary.ts` ga QO'SHILMAYDI** — u fayl
 * poydevorda muzlatilgan (rang palitrasi va `summarise` ni bir nechta
 * blok o'qiydi). Tip esa AYNI fayldan import qilinadi, nusxalanmaydi:
 * bir modul ichidagi ikki ta'rif jimgina ajralardi.
 *
 * Generik — chaqiruvchi `AttendanceDayLike` dan kengroq tip
 * (`AttendanceDay`, ya'ni `id` bilan) uzatsa ham natija shu tipda qoladi.
 */
export function recentRows<T extends { workDate: string }>(days: T[], n: number): T[] {
	return days.slice(-n).reverse();
}
